import { make } from 'vuex-pathify';
import { BankAccountTypeService } from '../services/bank-account-types.service.js';
import Logger from '@/lib/logger.js';

const service = new BankAccountTypeService();

const state = {
  bankAccountTypes: []
};

const mutations = make.mutations(state);

const actions = {
  async fetchBankAccountTypes({ commit }, payload) {
    try {
      const { data } = await service.fetchBankAccountTypes();
      commit('SET_BANK_ACCOUNT_TYPES', data);
      return data
    } catch (error) {
      Logger.error('Error while Getting Bank Account Types', error);
      throw error;
    }
  },

  async updateBankAccountType({ dispatch }, payload) {
    try {
      const { data } = await service.updateBankAccountType(payload.id, payload.updates)
      dispatch('fetchBankAccountTypes')
      return data
    } catch (error) {
      Logger.error('Error while Updating Bank Account Types', error);
      throw error;
    }
  }
};

export default {
  state,
  mutations,
  actions
};